<template>
  <div class="row">
    <div class="col">
      <label>Wybierz składnik:</label>
      <v-select :options="products" label="name" v-model="selectedItem.rawMaterial"></v-select>
    </div>
    <div class="col" v-if="selectedItem.rawMaterial">
      <label>Rodzaj produktu</label>
      <v-select label="text" :options="rawMaterialTypes" v-model="selectedItem.rawMaterial.productType" :reduce="(x) => x.value"></v-select>
    </div>
    <div class="col" v-else>
      <label>Rodzaj produktu</label>
      <v-select label="text" :options=[] />
    </div>

    <div class="col">
      <label>Waga</label>
      <input type="number" class="form-control" step="0.001" v-model="selectedItem.rawMaterialWeight" />
    </div>
  </div>
</template>

<script>
import deliveryMixins from '../../../../mixins/delivery';

export default {
  name: "recipeAdministrationItem",
  mixins: [deliveryMixins],
  computed: {
    products() {
      return this.$store.state.deliveryFormData.rawMaterialTypes;
    },
  },
  mounted() {
    this.$store.dispatch("getDeliveryFromData");
  },
  data() {
    return {};
  },
  props: ["selectedItem",],
  methods: {},
};
</script>